// Components==============
import { motion } from 'framer-motion';
import React, { useContext, useRef } from 'react';
import { OverOrionContext } from 'screens/OverOrion';
import { useOnClickOutside } from 'utilities/useOnClickOutside';
import './index.module.scss';
import location from './location.svg';
// =========================

export default function Location({ index, map = false }) {
    const { setSelected } = useContext(OverOrionContext);

    function handleClick() {
        if (map) {
            setSelected(index);
        }
    }

    const ref = useRef();

    useOnClickOutside(ref, () => setSelected(0));

    return (
        <motion.div
            styleName={`wrapper ${!map ? 'no-map' : ''}`}
            whileHover={{ scale: 1.25 }}
            whileTap={{ scale: 1 }}
            initial={{ x: '-50%', y: '-100%' }}
            onClick={handleClick}
            ref={ref}
        >
            <img src={location} alt="location" />
            <p>{index}</p>
        </motion.div>
    );
}
